import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import './global.css';

import { ManagerRouting } from './app/routing';

const root = document.getElementById('root') as HTMLElement;
ReactDOM.createRoot(root).render(<ManagerRouting />);
